// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2EH1_","tab":"Tabs_tab__1I7dC","tabActive":"Tabs_tabActive__1NHtG"};